<!--
   Copyright (C) GridGain Systems. All Rights Reserved.
   _________        _____ __________________        _____
   __  ____/___________(_)______  /__  ____/______ ____(_)_______
   _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
   / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
   \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
-->

<div class="empty-state__wrapper">
  <!-- Last visible element when the height is too low -->
  <div class="empty-state__item"></div>
  <div class="empty-state__action empty-state__item">
    <ng-content select="[empty-state-action]"></ng-content>
  </div>
  <div class="empty-state__description empty-state__item">
    <ng-content select="[empty-state-description]"></ng-content>
  </div>
  <div class="empty-state__title empty-state__item">
    <ng-content select="[empty-state-title]"></ng-content>
  </div>
  @if (illustration) {
    <div class="empty-state__item empty-state__item-illustration">
      <div class="empty-state__illustration">
        <ng-content select="[empty-state-illustration]"></ng-content>
      </div>
    </div>
  }
</div>
